// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".toolbarContainer--m1J5h7Ac {\n  height: var(--editor-brick-toolbar-height);\n  display: grid;\n  padding: 0 10px 0 0;\n  align-items: center;\n  justify-content: space-between;\n  grid-auto-flow: column;\n  box-shadow: 0px 3px 10px 0px rgba(128, 128, 128, 0.15);\n  background: rgba(255, 255, 255, 1);\n}\n\n.toolbarRight--3sWVjYy5 {\n  display: inline-grid;\n  grid-auto-flow: column;\n  align-items: center;\n}\n\n.toolbarLeft--Q_NQJiu6 {\n  display: inline-grid;\n  grid-auto-flow: column;\n  align-items: center;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"toolbarContainer": "toolbarContainer--m1J5h7Ac",
	"toolbarRight": "toolbarRight--3sWVjYy5",
	"toolbarLeft": "toolbarLeft--Q_NQJiu6"
};
export default ___CSS_LOADER_EXPORT___;
